//文字コードはutf-8

export function initCursorFollow() {
    const triggers = document.querySelectorAll('.jsCursor');
    if (!triggers.length) return;

    const circle = document.createElement('div');
    circle.className = 'jsCursor__circle';
    circle.innerHTML = '<span class="jsCursor__circle__text">VIEW MORE</span>';
    document.body.appendChild(circle);

    let isActive = false;
    let isAnimating = false;
    let mouseX = 0;
    let mouseY = 0;
    let circleX = 0;
    let circleY = 0;
    let rafId = null;
    let leaveTimerId = null;
    let lastLeaveTime = 0;

    // CSS transition duration for the shrink animation (ms)
    const SHRINK_DURATION = 250;
    function animate() {
        circleX += (mouseX - circleX) * 0.15;
        circleY += (mouseY - circleY) * 0.15;
        circle.style.left = circleX + 'px';
        circle.style.top = circleY + 'px';

        if (isActive || isAnimating) {
            rafId = requestAnimationFrame(animate);
        }
    }

    triggers.forEach(trigger => {
        trigger.addEventListener('mouseenter', (e) => {
            isActive = true;
            isAnimating = false;
            mouseX = e.clientX;
            mouseY = e.clientY;

            // Snap only if enough time has passed since last leave
            if (Date.now() - lastLeaveTime > (SHRINK_DURATION+100)) {
                circleX = mouseX;
                circleY = mouseY;
            }

            if (leaveTimerId) {
                clearTimeout(leaveTimerId);
                leaveTimerId = null;
            }
            circle.classList.add('is-active');
            trigger.classList.add('is-hover');
            if (!rafId) {
                rafId = requestAnimationFrame(animate);
            }
        });

        trigger.addEventListener('mousemove', (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
        });

        trigger.addEventListener('mouseleave', () => {
            isActive = false;
            isAnimating = true;
            lastLeaveTime = Date.now();
            circle.classList.remove('is-active');
            trigger.classList.remove('is-hover');

            // Keep following the cursor during the shrink animation
            leaveTimerId = setTimeout(() => {
                isAnimating = false;
                leaveTimerId = null;
                if (rafId) {
                    cancelAnimationFrame(rafId);
                    rafId = null;
                }
            }, SHRINK_DURATION);
        });
    });

    // Track mouse position globally so it updates even outside trigger areas
    document.addEventListener('mousemove', (e) => {
        if (isAnimating) {
            mouseX = e.clientX;
            mouseY = e.clientY;
        }
    });
}
